import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { Outlet } from '@tanstack/react-router'
import { TooltipProvider } from '@/components/ui/tooltip'
import Topbar from './Topbar'
import Sidebar from './Sidebar'
import BottomTabBar from './BottomTabBar'
import MobileNavSheet from './MobileNavSheet'
import { useUIStore } from '@/stores/uiStore'
import { api } from '@/lib/api/client'

interface MeResponse { roles: string[]; canImpersonate: boolean; canViewOthersTime: boolean }
export interface ForgeModule { key: string; displayName: string; isActive: boolean; isProd: boolean }

interface AppShellProps {
  user: { username?: string; name?: string; idTokenClaims?: Record<string, unknown> } | undefined
}

export default function AppShell({ user }: AppShellProps) {
  const { theme, sidebarCollapsed } = useUIStore()

  const { data: me } = useQuery({
    queryKey: ['me'],
    queryFn: () => api.get<MeResponse>('/me'),
    staleTime: 5 * 60 * 1000,
  })

  const { data: modules = [] } = useQuery({
    queryKey: ['forge-modules'],
    queryFn: () => api.get<ForgeModule[]>('/modules'),
    staleTime: 10 * 60 * 1000,
  })

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme)
  }, [theme])

  useEffect(() => {
    api.post('/users/provision', {}).catch(() => {})
  }, [])

  const roles = me?.roles ?? []

  return (
    <TooltipProvider>
      <div className="app" data-rail={sidebarCollapsed ? 'collapsed' : 'expanded'}>
        <Topbar user={user} />
        <Sidebar user={user} roles={roles} modules={modules} />
        <main className="main">
          <Outlet />
        </main>
        <BottomTabBar />
        <MobileNavSheet />
      </div>
    </TooltipProvider>
  )
}
